import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'

import * as entity from '@boutique/entities'
import * as url from '@bob/url'

type AssociatedContentsProps = {
  brand: entity.brand.Brand
}

export function AssociatedContents({ brand }: AssociatedContentsProps): React.ReactElement {
  if (brand.articles.length === 0) {
    return <></>
  }

  return (
    <Container>
      <ds.styles.heading.Title3 as="h3">{brand.name} sur Bien ou Bien, sélections et articles</ds.styles.heading.Title3>
      <ds.LineGridLayout>
        {brand.articles.map((article) => {
          return (
            <ds.ArticleCard
              key={article.slug}
              href={url.article({ slug: article.slug, title: article.title }).path}
              date={new Date(article.firstPublishedAt ?? '').toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              })}
              image={article.image}
              tag={article.category.name}
              title={article.title}
            />
          )
        })}
      </ds.LineGridLayout>
    </Container>
  )
}

const Container = styled(ds.Container)`
  ${ds.styles.heading.Title3} {
    margin: 80px 0 40px;
  }

  ${ds.LineGridLayout} {
    width: 100%;
    margin-bottom: 80px;
  }
`
